import React, { memo } from 'react';

import isEqual from 'lodash/isEqual';
import Loadable from 'react-loadable';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import type { HubEditorConfigPanelProps } from './hub-editor-config-panel/types';

export const LazyHubEditorConfigPanel = Loadable({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "@atlaskit-internal_hub-editor-config-panel" */
				'./hub-editor-config-panel'
			)
		).HubEditorConfigPanel,
	loading: () => <UFOLoadHold name="editor-config-panel-chunk-loader"></UFOLoadHold>,
});

export const HubEditorConfigPanelEntryPoint = memo(
	({
		localId,
		closeConfigPanel,
		contentId,
		editorActions,
		editorApi,
		propsProvider,
	}: HubEditorConfigPanelProps) => {
		if (localId) {
			return (
				<LazyHubEditorConfigPanel
					localId={localId}
					closeConfigPanel={closeConfigPanel}
					contentId={contentId}
					editorActions={editorActions}
					editorApi={editorApi}
					propsProvider={propsProvider}
				/>
			);
		}

		return null;
	},
	isEqual,
);
